import { registerView } from "@frui.ts/views";
import type { ViewComponent } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import { toolbarContext } from "../searchResultsView";
import VehicleRegisterViewModel from "viewModels/callCenter/search/vehicleRegister/vehicleRegisterViewModel";

const VehicleRegisterViewView: ViewComponent<VehicleRegisterViewModel> = observer(({ vm }) => {
  return null;
});

registerView(VehicleRegisterViewView, VehicleRegisterViewModel, toolbarContext);
